import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from './root-reducer'
import type { SharedData } from './shared-state'

/** The shared slices as one object. Memoized, so it only changes identity when some shared slice changes. */
export const selectSharedData = createSelector(
  [
    (state: RootState) => state.directory,
    (state: RootState) => state.projects,
    (state: RootState) => state.assets,
    (state: RootState) => state.designs,
    (state: RootState) => state.reviews,
    (state: RootState) => state.notifications,
  ],
  (directory, projects, assets, designs, reviews, notifications): SharedData => ({
    directory,
    projects,
    assets,
    designs,
    reviews,
    notifications,
  }),
)
